import styled from 'styled-components';

export const ButtonWrapper = styled.button`
    width: 100%;
    height: 47px;
    margin-top: 10px;
    background-color: black;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-width: 0;
`;



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ApplePayButton/style.js